import React from "react";
import { Link } from "react-router-dom";
import { Modal } from "components";
import Constants from "app_constants";
import Theme from "./theme";

const PasswordResetView = (props) => {
  const {
    resetPassword,
    setFormData,
    error,
    resetPasswordModal,
    showResetPasswordModal,
    email,
  } = props;

  return (
    <Theme>
      {Constants.metaTag}

      {
        <Modal
          title="Successful"
          content="Your new password has been sent to your e-mail."
          modalActive={resetPasswordModal}
          showModal={showResetPasswordModal}
        />
      }

      <div class="box">
        <div className="panel">
          <div className="field">
            <label className="label">E-mail</label>
            <div className="control">
              <input
                value={email}
                onChange={(e) => {
                  setFormData("email", e.target.value);
                }}
                className="input is-info"
                type="text"
              />
            </div>
          </div>
          {error && <p className="error">{error}</p>}
          <button
            onClick={resetPassword}
            className="button is-info is-fullwidth submit"
          >
            Reset Password
          </button>

          <div className="bottomSection">
            <Link to="/login">
              <p className="link">Login</p>
            </Link>

            <Link to="/register">
              <p className="link">Sign Up</p>
            </Link>
          </div>
        </div>
      </div>
    </Theme>
  );
};

export default PasswordResetView;
